import { render, staticRenderFns } from "./promotion-detail-goods.vue?vue&type=template&id=2d09c5c3&"
import script from "./promotion-detail-goods.vue?vue&type=script&lang=js&"
export * from "./promotion-detail-goods.vue?vue&type=script&lang=js&"
import style0 from "./promotion-detail-goods.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports